var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.48 3H7.52C4.07 3 2 5.06 2 8.52V16.47C2 19.94 4.07 22 7.52 22H15.47C18.93 22 20.99 19.94 20.99 16.48V8.52C21 5.06 18.93 3 15.48 3Z",
    fill: "#6A639C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.02 2.98028C19.23 1.18028 17.48 1.14028 15.64 2.98028L14.51 4.10028C14.41 4.20028 14.38 4.34028 14.42 4.47028C15.12 6.92028 17.08 8.88028 19.53 9.58028C19.56 9.59028 19.61 9.59028 19.64 9.59028C19.74 9.59028 19.84 9.55028 19.91 9.48028L21.02 8.36028C21.93 7.45028 22.38 6.58028 22.38 5.69028C22.38 4.79028 21.93 3.90028 21.02 2.98028Z",
    fill: "#6A639C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86 10.4198C17.59 10.2898 17.33 10.1598 17.09 10.0098C16.89 9.88984 16.69 9.75984 16.5 9.61984C16.34 9.51984 16.16 9.36984 15.98 9.21984C15.96 9.20984 15.9 9.15984 15.82 9.07984C15.51 8.82984 15.18 8.48984 14.87 8.11984C14.85 8.09984 14.79 8.03984 14.74 7.94984C14.64 7.83984 14.49 7.64984 14.36 7.43984C14.25 7.29984 14.12 7.09984 14 6.88984C13.85 6.63984 13.72 6.38984 13.6 6.12984C13.47 5.84984 13.37 5.58984 13.28 5.33984L7.89998 10.7198C7.54998 11.0698 7.20998 11.7298 7.13998 12.2198L6.70998 15.1998C6.61998 15.8298 6.78998 16.4198 7.17998 16.8098C7.50998 17.1398 7.95998 17.3098 8.45998 17.3098C8.56998 17.3098 8.67998 17.2998 8.78998 17.2898L11.76 16.8698C12.25 16.7998 12.91 16.4698 13.26 16.1098L18.64 10.7298C18.39 10.6498 18.14 10.5398 17.86 10.4198Z",
    fill: "#6A639C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c1e979610b4388bfd4bb56e3e069ca6f.svg";
export { ForwardRef as ReactComponent };